// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Env vars (set in .env) take precedence; the hardcoded values are fallbacks.
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://ferpxxmalnacuojdkxxa.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImZlcnB4eG1hbG5hY3VvamRreHhhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg4OTQ3NTMsImV4cCI6MjA2NDQ3MDc1M30.qGx629iwJ1dbUPZGpL3DIgzGvsDH56kuvAk7sLmuKj0";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});
